<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ data.title || "\u00a0" }}</h1>
      <b-row class="mb-5">
        <b-col class="col-12">
          <p>{{ $t('unite_colonies_or_remove_queen.text') }}</p>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent text-primary border-primary border form-control text-center" :title="$t('unite_colonies_or_remove_queen.cancel')" :to="'/apiaries'">
            {{ $t('unite_colonies_or_remove_queen.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6">
          <b-link class="bg-primary text-light form-control text-center" :title="$t('unite_colonies_or_remove_queen.remove_queen')" :to="'/unite-colonies-or-remove-queen2/' + queen + '/' + colony">
            {{ $t('unite_colonies_or_remove_queen.remove_queen') }}
          </b-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12">
          <b-link class="bg-primary text-light form-control text-center" :title="$t('unite_colonies_or_remove_queen.unite_colonies')" :to="'/unite-colonies/' + colony">
            {{ $t('unite_colonies_or_remove_queen.unite_colonies') }}
          </b-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'UniteColoniesOrRemoveQueen',
  props: ['queen', 'colony'],
  data () {
    return {
      showError: false,
      loaded: false,
      data: {
        title: null
      }
    }
  },
  async mounted () {
    if (this.colony) {
      try {
        this.data = await this.$api.colonies.getOne(this.colony)
        if (this.data) {
          this.loaded = true
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style scoped>
  .container {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
